
import { Component, Vue } from 'vue-property-decorator'
import { UserModule } from '@/store/modules/user'

@Component({
  name: 'Dashboard'
})
export default class extends Vue {
  get name() {
    return UserModule.userInfo?.username
  }

  get roles() {
    return UserModule.roles
  }

  get userInfo() {
    return UserModule.userInfo
  }

  get permissions() {
    return UserModule.permissions
  }

  get hasInitedPermission() {
    return UserModule.hasInitedPermission
  }

  get orgs() {
    return UserModule.orgs
  }

  get currentOrg() {
    return UserModule.currentOrg
  }

  get depts() {
    return UserModule.depts
  }

  get projects() {
    return UserModule.projects
  }

  get allInfo() {
    return {
      userInfo: this.userInfo,
      permissions: this.permissions,
      hasInitedPermission: this.hasInitedPermission,
      orgs: this.orgs,
      currentOrg: this.currentOrg,
      depts: this.depts,
      projects: this.projects
    }
  }
}
